// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --color: white;
  --box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
  --padding-top: 10px;
  --padding-bottom: 10px;
}

.price {
  display: inline-block;
  padding: 10px 10px 10px 18px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}

.package-modal {
  height: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.package-header {
  text-align: center;
  margin-bottom: 32px;
}

.price-tag {
  display: inline-block;
  background: var(--ion-color-primary);
  padding: 12px 24px;
  border-radius: 50px;
  color: white;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.price-tag .amount {
  font-size: 24px;
  font-weight: 700;
}
.price-tag .period {
  font-size: 16px;
  opacity: 0.9;
}

.package-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--ion-color-dark);
  margin: 0;
}

.package-content {
  flex: 1;
}
.package-content .description {
  text-align: center;
  color: var(--ion-color-medium);
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 32px;
  padding: 0 16px;
}

.features {
  padding: 0 16px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.feature-item ion-icon {
  color: var(--ion-color-success);
  font-size: 24px;
  margin-right: 12px;
}
.feature-item span {
  color: var(--ion-color-dark);
  font-size: 16px;
}

.package-footer {
  margin-top: auto;
  padding-top: 24px;
}

.select-button {
  --background: var(--ion-color-primary);
  --background-hover: var(--ion-color-primary-shade);
  --border-radius: 12px;
  --padding-top: 16px;
  --padding-bottom: 16px;
  font-weight: 600;
  font-size: 16px;
  text-transform: none;
}
.select-button::part(native) {
  box-shadow: 0 4px 12px rgba(var(--ion-color-primary-rgb), 0.3);
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/modals/select-package/select-package.component.scss"],"names":[],"mappings":"AAAA;EAEI,cAAA;EAEA,6CAAA;EAEA,mBAAA;EACA,sBAAA;AAFJ;;AAMA;EACI,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;AAHJ;;AAMA;EACE,YAAA;EACA,6DAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;AAHF;AAKE;EACE,eAAA;EACA,gBAAA;AAHJ;AAME;EACE,eAAA;EACA,YAAA;AAJJ;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;AALF;;AAQA;EACE,OAAA;AALF;AAOE;EACE,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AALJ;;AASA;EACE,eAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AANF;AAQE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;AANJ;AASE;EACE,4BAAA;EACA,eAAA;AAPJ;;AAWA;EACE,gBAAA;EACA,iBAAA;AARF;;AAWA;EACE,sCAAA;EACA,kDAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AARF;AAUE;EACE,8DAAA;AARJ","sourcesContent":["ion-button {\r\n\r\n    --color: white;\r\n  \r\n    --box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);\r\n\r\n    --padding-top: 10px;\r\n    --padding-bottom: 10px;\r\n\r\n  }\r\n\r\n.price {\r\n    display: inline-block;\r\n    padding: 10px 10px 10px 18px;\r\n    border-top-left-radius: 25px;\r\n    border-bottom-left-radius: 25px;\r\n}\r\n\r\n.package-modal {\r\n  height: 100%;\r\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\r\n  padding: 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.package-header {\r\n  text-align: center;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.price-tag {\r\n  display: inline-block;\r\n  background: var(--ion-color-primary);\r\n  padding: 12px 24px;\r\n  border-radius: 50px;\r\n  color: white;\r\n  margin-bottom: 16px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n\r\n  .amount {\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .period {\r\n    font-size: 16px;\r\n    opacity: 0.9;\r\n  }\r\n}\r\n\r\n.package-title {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  color: var(--ion-color-dark);\r\n  margin: 0;\r\n}\r\n\r\n.package-content {\r\n  flex: 1;\r\n  \r\n  .description {\r\n    text-align: center;\r\n    color: var(--ion-color-medium);\r\n    font-size: 16px;\r\n    line-height: 1.6;\r\n    margin-bottom: 32px;\r\n    padding: 0 16px;\r\n  }\r\n}\r\n\r\n.features {\r\n  padding: 0 16px;\r\n}\r\n\r\n.feature-item {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n  \r\n  ion-icon {\r\n    color: var(--ion-color-success);\r\n    font-size: 24px;\r\n    margin-right: 12px;\r\n  }\r\n\r\n  span {\r\n    color: var(--ion-color-dark);\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n.package-footer {\r\n  margin-top: auto;\r\n  padding-top: 24px;\r\n}\r\n\r\n.select-button {\r\n  --background: var(--ion-color-primary);\r\n  --background-hover: var(--ion-color-primary-shade);\r\n  --border-radius: 12px;\r\n  --padding-top: 16px;\r\n  --padding-bottom: 16px;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  text-transform: none;\r\n  \r\n  &::part(native) {\r\n    box-shadow: 0 4px 12px rgba(var(--ion-color-primary-rgb), 0.3);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
